import { Colors } from '@/components/common';

export default {
  methods: {
    getColor: (status) => {
      let color = '';
      switch (status) {
        case true:
          color = Colors.GREEN;
          break;
        case false:
          color = Colors.GRAY;
          break;
      }
      return color;
    },
  },
};
